
import api from './api';

const endpoint = '/api/avisos';
const CACHE_TTL = 4 * 60 * 60 * 1000;

//Verifica validade do cachê
function getFromCache(cacheKey) {
  const raw = localStorage.getItem(cacheKey);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);

    if (!parsed.data || !parsed.timestamp) return null;

    const expired = Date.now() - parsed.timestamp > CACHE_TTL;
    if (expired) return null;

    return parsed.data;
  } catch {
    return null;
  }
}


// Grava no cache com data + timestamp.
function saveToCache(cacheKey, data) {
  localStorage.setItem(
    cacheKey,
    JSON.stringify({
      data,
      timestamp: Date.now(),
    })
  );
}


const AvisosService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getById: async (id) => {
    const cacheKey = `avisos_${id}`;

    const cached = getFromCache(cacheKey);
    if (cached) return cached;

    const response = await api.get(`${endpoint}/id/${id}`);

    saveToCache(cacheKey, response.data);
    
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default AvisosService;